
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-renewal",
      function () {
        return require("private-next-pages/service-renewal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-renewal"])
      });
    }
  